import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";

import HttpManager from "../../../../services/HttpManager";
import { Extension } from "../../../../services/v2/telefonia.service";
import { Aviso, Check, errorTexto, hace, minutos, num, plantelNombre, telBonito } from "./comunes";
import { Compartido } from "./telefoniaController";

/** Extensiones: quién tiene teléfono en WAPP, en qué plantel y equipo, si graba y con qué número sale. Alta sin tocar código. */
const Extensiones: React.FC<{ sh: Compartido }> = ({ sh }) => {
	const http = HttpManager.getInstance();
	const [error, setError] = useState<string | null>(null);
	const [aviso, setAviso] = useState<string | null>(null);
	const [nueva, setNueva] = useState<boolean>(false);
	const [edit, setEdit] = useState<Extension | null>(null);
	const [q, setQ] = useState<string>("");

	const accion = async (fn: () => Promise<any>, ok?: string) => {
		setError(null); setAviso(null);
		try { const r = await fn(); sh.setExtensiones(r.data.extensiones); if (ok) setAviso(ok); } catch (e) { setError(errorTexto(e)); }
	};
	const lista = sh.extensiones.filter((e) => !q || (e.name + " " + e.extension + " " + (e.team || "") + " " + (e.email || "")).toLowerCase().includes(q.toLowerCase()));

	return (
		<>
			<div className="tf-filtros">
				<input type="search" className="nu-buscar" placeholder="Buscar por nombre, extensión o equipo" value={q} onChange={(e) => setQ(e.target.value)} />
				<span className="nu-tenue">{sh.extensiones.length} extensiones · {sh.extensiones.filter((e) => e.bool_online).length} conectadas</span>
				<span style={{ flex: 1 }} />
				<button className="nu-btn pri" onClick={() => setNueva(true)}>+ Dar extensión</button>
			</div>
			<Aviso texto={error} onClose={() => setError(null)} /><Aviso texto={aviso} tipo="ok" onClose={() => setAviso(null)} />
			<div className="nu-bloque">
				<table className="nu-tabla">
					<thead><tr><th>Ext.</th><th className="izq">Nombre</th><th className="izq">Equipo</th><th className="izq">Plantel</th><th className="izq">Estado</th><th>Hoy</th><th className="izq">Sale con</th><th className="izq">Graba</th><th></th></tr></thead>
					<tbody>
						{lista.map((e) => (
							<tr key={e.id} className={e.bool_enabled ? "" : "apagado"}>
								<td><b>{e.extension}</b></td>
								<td className="izq">{e.name}<br /><span className="nu-tenue">{e.email}</span></td>
								<td className="izq">{e.team || "–"}</td>
								<td className="izq">{plantelNombre(sh.cat, e.campus_id)}</td>
								<td className="izq">{!e.bool_enabled ? <span className="tf-chip gris">Apagada</span> : e.en_llamada ? <span className="tf-chip ok">En llamada</span> : e.bool_online ? <span className="tf-chip in">Conectada</span> : <span className="tf-chip gris">Desconectada · {hace(e.last_seen_at)}</span>}</td>
								<td>{num(e.hoy.llamadas)} <span className="nu-tenue">· {num(e.hoy.contestadas)} ok · {minutos(e.hoy.segundos)}</span></td>
								<td className="izq">{e.caller_id ? telBonito(e.caller_id) : <span className="nu-tenue">el del plantel</span>}</td>
								<td className="izq">{e.bool_record ? "Sí" : <span className="tf-chip oro">No</span>}</td>
								<td className="tf-acciones">
									<button className="nu-btn chico" onClick={() => setEdit(e)}>Editar</button>
									<button className="nu-btn chico" onClick={() => accion(() => http.telefoniaService.actualizarExtension(sh.campusId, e.id, { enabled: !e.bool_enabled }), e.bool_enabled ? "Extensión apagada." : "Extensión encendida.")}>{e.bool_enabled ? "Apagar" : "Encender"}</button>
								</td>
							</tr>
						))}
						{!lista.length ? <tr><td colSpan={9} className="nu-vacio">Nadie tiene extensión todavía. Dale una a cada asesora o deja que se cree sola la primera vez que encienda el teléfono.</td></tr> : null}
					</tbody>
				</table>
				<div className="nu-tenue" style={{ marginTop: 8 }}>Rangos: 1xx Monterrey · 2xx Torreón · 3xx Tegucigalpa · 4xx San Pedro Sula · 5xx Online. Una asesora sin extensión recibe una sola al encender el teléfono.</div>
			</div>
			{nueva ? <NuevaExtension sh={sh} onClose={() => setNueva(false)} onHecho={(exts, msg) => { sh.setExtensiones(exts); setNueva(false); setAviso(msg); }} /> : null}
			{edit ? <EditarExtension sh={sh} e={edit} onClose={() => setEdit(null)} onHecho={(exts, msg) => { sh.setExtensiones(exts); setEdit(null); setAviso(msg); }} /> : null}
		</>
	);
};

const NuevaExtension: React.FC<{ sh: Compartido; onClose: () => void; onHecho: (e: Extension[], msg: string) => void }> = ({ sh, onClose, onHecho }) => {
	const http = HttpManager.getInstance();
	const [q, setQ] = useState<string>("");
	const [usuarios, setUsuarios] = useState<{ id: number; name: string; email: string; campus_id: number | null }[]>([]);
	const [u, setU] = useState<{ id: number; name: string; email: string; campus_id: number | null } | null>(null);
	const [campus, setCampus] = useState<number>(sh.cat.planteles[0]?.id || sh.campusId);
	const [ext, setExt] = useState<string>("");
	const [team, setTeam] = useState<string>("");
	const [busy, setBusy] = useState<boolean>(false);
	const [error, setError] = useState<string | null>(null);
	useEffect(() => {
		const t = setTimeout(() => http.telefoniaService.usuarios(sh.campusId, q).then((r) => setUsuarios(r.data.usuarios)).catch(() => undefined), 250);
		return () => clearTimeout(t);
	}, [q]);
	const guardar = async () => {
		if (!u) return;
		setBusy(true); setError(null);
		try { const r = await http.telefoniaService.crearExtension(sh.campusId, { user_id: u.id, campus_id: campus, extension: ext || undefined, team: team || undefined }); onHecho(r.data.extensiones, "Extensión creada para " + u.name + "."); }
		catch (e) { setError(errorTexto(e)); } finally { setBusy(false); }
	};
	return (
		<Modal show onHide={onClose} className="ventas-nuevo-modal">
			<Modal.Header closeButton><Modal.Title style={{ fontFamily: "Bricolage, sans-serif", fontWeight: 800 }}>Dar extensión</Modal.Title></Modal.Header>
			<Modal.Body className="tf">
				<div className="tf-campo"><label>¿A quién?</label><input type="search" placeholder="Escribe el nombre o correo" value={q} onChange={(e) => setQ(e.target.value)} autoFocus /></div>
				<div className="tf-sugerencias" style={{ marginTop: 6 }}>
					{usuarios.map((x) => <button key={x.id} className={u?.id === x.id ? "on" : ""} onClick={() => { setU(x); if (x.campus_id && sh.cat.planteles.some((p) => p.id === x.campus_id)) setCampus(x.campus_id); }}>{x.name}<small>{x.email}</small></button>)}
					{!usuarios.length ? <span className="nu-tenue" style={{ padding: 8 }}>Sin resultados (solo aparece gente con rol en WAPP y sin extensión).</span> : null}
				</div>
				<div className="cp-dos" style={{ marginTop: 12 }}>
					<div><label>Plantel (define el rango)</label><select value={campus} onChange={(e) => setCampus(Number(e.target.value))}>{sh.cat.planteles.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}</select></div>
					<div><label>Número de extensión (opcional)</label><input type="text" placeholder="la primera libre" value={ext} onChange={(e) => setExt(e.target.value.replace(/\D/g, "").slice(0, 3))} /></div>
					<div><label>Equipo (opcional)</label><input type="text" list="tf-equipos" value={team} onChange={(e) => setTeam(e.target.value)} placeholder="el de su rol en Zoho" /><datalist id="tf-equipos">{sh.cat.equipos.map((t) => <option key={t} value={t} />)}</datalist></div>
				</div>
				{error ? <Aviso texto={error} /> : null}
			</Modal.Body>
			<Modal.Footer><button className="nu-btn" onClick={onClose}>Cancelar</button><button className="nu-btn pri" disabled={!u || busy} onClick={guardar}>Crear extensión</button></Modal.Footer>
		</Modal>
	);
};

const EditarExtension: React.FC<{ sh: Compartido; e: Extension; onClose: () => void; onHecho: (e: Extension[], msg: string) => void }> = ({ sh, e, onClose, onHecho }) => {
	const http = HttpManager.getInstance();
	const [v, setV] = useState<any>({ name: e.name, extension: e.extension, campus_id: e.campus_id || sh.campusId, team: e.team || "", caller_id: e.caller_id || "", record: e.bool_record, enabled: e.bool_enabled });
	const [busy, setBusy] = useState<boolean>(false);
	const [error, setError] = useState<string | null>(null);
	const guardar = async () => {
		setBusy(true); setError(null);
		try { const r = await http.telefoniaService.actualizarExtension(sh.campusId, e.id, v); onHecho(r.data.extensiones, "Extensión guardada."); }
		catch (x) { setError(errorTexto(x)); } finally { setBusy(false); }
	};
	const clave = async () => {
		if (!window.confirm("Se genera una clave nueva; el teléfono de " + e.name + " se vuelve a conectar solo. ¿Seguir?")) return;
		setBusy(true); try { const r = await http.telefoniaService.nuevaClave(sh.campusId, e.id); onHecho(r.data.extensiones, "Clave nueva generada."); } catch (x) { setError(errorTexto(x)); } finally { setBusy(false); }
	};
	const borrar = async () => {
		if (!window.confirm("¿Quitar la extensión " + e.extension + " de " + e.name + "? Su historial de llamadas se conserva.")) return;
		setBusy(true); try { const r = await http.telefoniaService.borrarExtension(sh.campusId, e.id); onHecho(r.data.extensiones, "Extensión eliminada."); } catch (x) { setError(errorTexto(x)); } finally { setBusy(false); }
	};
	return (
		<Modal show onHide={onClose} className="ventas-nuevo-modal">
			<Modal.Header closeButton><Modal.Title style={{ fontFamily: "Bricolage, sans-serif", fontWeight: 800 }}>Extensión {e.extension}</Modal.Title></Modal.Header>
			<Modal.Body className="tf">
				<div className="cp-dos">
					<div><label>Nombre que ve quien recibe la llamada interna</label><input type="text" value={v.name} onChange={(x) => setV({ ...v, name: x.target.value })} /></div>
					<div><label>Número de extensión</label><input type="text" value={v.extension} onChange={(x) => setV({ ...v, extension: x.target.value.replace(/\D/g, "").slice(0, 3) })} /></div>
					<div><label>Plantel</label><select value={v.campus_id} onChange={(x) => setV({ ...v, campus_id: Number(x.target.value) })}>{sh.cat.planteles.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}</select></div>
					<div><label>Equipo</label><input type="text" list="tf-equipos2" value={v.team} onChange={(x) => setV({ ...v, team: x.target.value })} /><datalist id="tf-equipos2">{sh.cat.equipos.map((t) => <option key={t} value={t} />)}</datalist></div>
					<div><label>Número que muestra al llamar (vacío = el principal del plantel)</label><input type="text" placeholder="504 2234 5678" value={v.caller_id} onChange={(x) => setV({ ...v, caller_id: x.target.value })} /></div>
				</div>
				<div style={{ display: "flex", gap: 16, marginTop: 10, flexWrap: "wrap" }}>
					<Check checked={v.record} onChange={(b) => setV({ ...v, record: b })}>Grabar sus llamadas</Check>
					<Check checked={v.enabled} onChange={(b) => setV({ ...v, enabled: b })}>Encendida</Check>
				</div>
				{error ? <Aviso texto={error} /> : null}
			</Modal.Body>
			<Modal.Footer>
				<button className="nu-btn" onClick={borrar} disabled={busy}>Quitar extensión</button>
				<button className="nu-btn" onClick={clave} disabled={busy}>Clave nueva</button>
				<span style={{ flex: 1 }} />
				<button className="nu-btn" onClick={onClose}>Cancelar</button><button className="nu-btn pri" disabled={busy} onClick={guardar}>Guardar</button>
			</Modal.Footer>
		</Modal>
	);
};

export default Extensiones;
